import { NavLink } from 'react-router';
import type { Profil } from '@/api/types';
import { useSession } from '@/auth/session';
import { cn } from '@/lib/utils';

export const ACCES_ADMINISTRATION: Record<'utilisateurs' | 'bareme' | 'parametres' | 'destinataires' | 'services' | 'calendrier' | 'procedures' | 'audit', Profil[]> = {
  utilisateurs: ['ADMINISTRATEUR', 'DIRECTEUR_GENERAL'],
  bareme: ['ADMINISTRATEUR', 'DIRECTEUR_GENERAL', 'DIRECTEUR_FINANCIER', 'CONTROLE_GESTION'],
  parametres: ['ADMINISTRATEUR', 'DIRECTEUR_GENERAL'],
  destinataires: ['ADMINISTRATEUR', 'DIRECTEUR_GENERAL', 'DGA_FINANCES', 'DGA_OPERATIONS', 'DIRECTEUR_FINANCIER', 'CONTROLE_GESTION'],
  services: ['ADMINISTRATEUR', 'DIRECTEUR_GENERAL', 'DGA_FINANCES', 'DGA_OPERATIONS', 'DIRECTEUR_FINANCIER', 'CONTROLE_GESTION', 'CHEF_COMPTABLE'],
  calendrier: ['ADMINISTRATEUR', 'DIRECTEUR_RH', 'RESSOURCES_HUMAINES', 'DIRECTEUR_GENERAL'],
  procedures: ['ADMINISTRATEUR', 'DIRECTEUR_RH', 'RESSOURCES_HUMAINES'],
  audit: ['ADMINISTRATEUR', 'DIRECTEUR_GENERAL', 'DGA_FINANCES', 'DGA_OPERATIONS', 'DIRECTEUR_FINANCIER', 'CONTROLE_GESTION'],
};

const ONGLETS: Array<{ cle: keyof typeof ACCES_ADMINISTRATION; a: string; l: string }> = [
  { cle: 'utilisateurs', a: '/administration/utilisateurs', l: 'Utilisateurs et habilitations' },
  { cle: 'bareme', a: '/administration/bareme', l: 'Barème des missions' },
  { cle: 'parametres', a: '/administration/parametres', l: 'Paramètres' },
  { cle: 'destinataires', a: '/administration/destinataires', l: 'Destinataires des rapports' },
  { cle: 'services', a: '/administration/services', l: 'Services des directions' },
  { cle: 'calendrier', a: '/administration/calendrier', l: 'Calendrier RH (jours fériés)' },
  { cle: 'procedures', a: '/administration/procedures', l: 'Domaines des procédures' },
  { cle: 'audit', a: '/administration/audit', l: "Journal d'audit" },
];

/** Onglets accessibles selon les profils ; première entrée autorisée pour le menu. */
export function ongletsAutorises(profils: Profil[]): typeof ONGLETS {
  return ONGLETS.filter((o) => ACCES_ADMINISTRATION[o.cle].some((p) => profils.includes(p)));
}

export function OngletsAdministration() {
  const session = useSession();
  const onglets = ongletsAutorises(session?.utilisateur.profils ?? []);
  return (
    <nav className="mb-5 flex flex-wrap gap-1 border-b">
      {onglets.map((o) => (
        <NavLink key={o.a} to={o.a} className={({ isActive }) => cn('-mb-px border-b-2 px-3 py-2 text-sm', isActive ? 'border-primary font-medium text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground')}>
          {o.l}
        </NavLink>
      ))}
    </nav>
  );
}
